import http from '@/libs/AxiosPlugin'

const account = {
  list () {
    return http.get('/account/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, username: 'admin', name: 'DaviaLi', workNo: '123456', department: '人事部', workPosition: '职位', role: 'admin', phone: '12345678901', eMail: '123@qq.com', qq: '12345678', wechat: 'xxxxx'}
    //   ]
    //   resolve(data)
    // })
  },

  delete (id) {
    return http.post('/account/delete', {id})
  },

  get (id) {
    return http.post('/account/get', {id})
    // return Promise.resolve({id: 1, username: 'admin', name: 'DaviaLi', workNo: '123456', department: 1, workPosition: 2, role: 3, phone: '12345678901', eMail: '123@qq.com', qq: '12345678', wechat: 'xxxxx'})
  },
  reset (id) {
    return http.post('/account/reset', {id})
    // return Promise.resolve({id: 1, username: 'admin', name: 'DaviaLi', workNo: '123456', department: 1, workPosition: 2, role: 3, phone: '12345678901', eMail: '123@qq.com', qq: '12345678', wechat: 'xxxxx'})
  },
  save (account) {
    return http.post('/account/save', account)
    // return Promise.resolve()
  }
}

export default account



// WEBPACK FOOTER //
// ./src/api/account.js